import React from "react"
import { FormControlLabel, Checkbox, Button } from "@material-ui/core"
import { useFormContext } from "react-hook-form"
import { useCommonFieldProps } from "./CommonFieldPropsContext"

/**
 * This is currently disabled. Esri doesn't let you change whether
 * a field is nullable, so we have to build in our own by adding
 * it to the name, i.e. Field name:text:required
 */
export const CommonFieldOptions: React.FC = () => {
  /** Get common schema field props */
  const { index, field, remove } = useCommonFieldProps()

  /** Register the field with react-hook-form */
  const requiredFieldName = `fields[${index}].required`
  const { register } = useFormContext()

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            name={requiredFieldName}
            id={requiredFieldName}
            // @ts-ignore
            defaultChecked={Boolean(field.required)}
            value="required"
            inputRef={register()}
          />
        }
        label="Required"
      />
      <Button onClick={() => remove && remove(index)}>Remove</Button>
    </>
  )
}
